var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58368 1.58496C14.0157 1.58514 17.6247 5.19487 17.6247 9.62695C17.6245 14.0589 14.0156 17.6678 9.58368 17.668C5.1516 17.668 1.54186 14.059 1.54169 9.62695C1.54169 5.19476 5.15149 1.58496 9.58368 1.58496ZM9.58368 1.83496C5.28216 1.83496 1.79169 5.33452 1.79169 9.62695C1.79186 13.9192 5.28227 17.418 9.58368 17.418C13.8849 17.4178 17.3745 13.9191 17.3747 9.62695C17.3747 5.33462 13.885 1.83514 9.58368 1.83496Z",
    fill: "#98A2B3",
    stroke: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 19.0015C18.1754 19.0015 18.017 18.9432 17.892 18.8182L16.2254 17.1515C15.9837 16.9098 15.9837 16.5098 16.2254 16.2682C16.467 16.0265 16.867 16.0265 17.1087 16.2682L18.7754 17.9348C19.017 18.1765 19.017 18.5765 18.7754 18.8182C18.6504 18.9432 18.492 19.0015 18.3337 19.0015Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.a4e2536540cf906bf5075912536b44a0.svg";
export { ForwardRef as ReactComponent };